module.exports = __webpack_public_path__ + "static/img/seminar_poster.0040661f.jpg";